import React, { useEffect } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { usePersonDetailStore } from '../stores/personDetailStore'
import { PersonDetailBody } from './PersonDetailBody'
import { crmOrigin } from '../hooks/useOpenPerson'

// Full-page Person detail (route /crm/people/:id) — the only way the detail is
// opened, on every viewport. Loads the person into the shared detail store from
// the URL id alone, then renders the shared body full-screen.
export const PersonDetailPage = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const fetchPerson = usePersonDetailStore((state) => state.fetchPerson)

    useEffect(() => {
        if (id) fetchPerson(Number(id))
    }, [id])

    // Back pops to wherever the user came from (board, list, report). Two
    // entries can't pop: a direct one (pasted URL, bookmark, new tab — React
    // Router keys it 'default') and a CrmReturnLink from Calculate or a quote,
    // which sits right behind it. Those go to the CRM page the person was
    // opened from instead.
    const goBack = () => {
        if (location.key === 'default' || location.state?.crmReturn) navigate(crmOrigin())
        else navigate(-1)
    }

    return <PersonDetailBody onClose={goBack} />
}
